export const requiredNotZero = (t) => (value) => {
  return value && (parseInt(value) > 0 || parseInt(value) < 0) ? undefined : t('validation.Обязательное поле');
};

export const required = (t) => (value) => {
  const ok = value?.toString().trim();
  return ok ? undefined : t('validation.Обязательное поле');
};

export const maxTenMillionValue = (t) => (value) => {
  if (value && Number(value) > 10000000) {
    return t('validation.Максимальное значение') + ' 10.000.000';
  }
};

export const wospaces = (t) => (value) => {
  if (!value) {
    return undefined;
  }
  const ok = value?.toString().trim();
  return ok ? undefined : t('validation.Неверный формат');
};

export const itn = (t) => (value) => {
  if (value) {
    return value.length === 12 || value.length === 10 ? undefined : t('validation.В строке должно быть 10 или 12 символов');
  }
};

export const iec = (t) => (value) => {
  if (value) {
    return value.length === 9 ? undefined : t('validation.В строке должно быть 9 символов');
  }
};

export const psrn = (t) => (value) => {
  if (value) {
    return value.length === 13 ? undefined : t('validation.В строке должно быть 13 символов');
  }
};

export const psrnsp = (t) => (value) => {
  if (value) {
    return value.length === 15 ? undefined : t('validation.В строке должно быть 15 символов');
  }
};

export const okpo = (t) => (value) => {
  if (value) {
    return value.length === 8 || value.length === 10 ? undefined : t('validation.В строке должно быть 8 или 10 символов');
  }
};

export const isRfid = (t) => (value) => {
  if (value) {
    return value.length === 6 ? undefined : t('validation.В строке должно быть 6 символов');
  }
};

export const tariffIsCorrect = (t, tariffs) => (value) => {
  if (value) {
    if (Array.isArray(tariffs) && tariffs.length) {
      const isCorrect = tariffs.some((tariff) => {
        return tariff.name === value;
      });
      return isCorrect ? undefined : t('validation.Не найдено тарифа с данным именем');
    } else {
      return t('validation.Не найдено тарифа с данным именем');
    }
  }
};

export const min1 = (t) => (value) => {
  if (value === 0) {
    return t('validation.Заполните поле');
  }
  return parseInt(value) === 0 ? t('validation.Период не может быть равен 0 минут') : undefined;
};

export const isEmail = (t) => (email) => {
  if (!email) {
    return undefined;
  }
  const test = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  //const test = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return test.test(email) ? undefined : t('validation.Неверный формат');
};

export const preparePhone = (phone) => {
  if (!phone) {
    return '';
  }
  let out = phone.replaceAll(' ', '').replaceAll('(', '').replaceAll(')', '').replaceAll('-', '').trim();
  if (!out) {
    return out;
  }
  if (out.charAt(0) !== '+') {
    if (out.charAt(0) === '8') {
      out = out.replaceAt(0, '7');
    }
    out = '+' + out;
  }
  if (out === '+7') {
    out = '';
  }
  return out;
};

export const isPhone =
  (t, req = false) =>
  (phone) => {
    if (!phone) {
      return req ? t('validation.Обязательное поле') : undefined;
    }
    const test = /^[+][1-9]{1}[0-9]{3}[0-9]{3}[0-9]{4}$/im;
    return test.test(preparePhone(phone).trim()) ? undefined : t('validation.Неверный формат');
  };

export const checkFn = (t) => (value) => {
  const ok = required(t)(value);
  if (ok === undefined) {
    return value.length === 16 ? undefined : t('messages.В номере должно быть 16 символов');
  } else {
    return t('validation.Обязательное поле');
  }
};

export const minValue = (t, min) => (value) => {
  const val = value ?? 0; //Number(value)
  return val < min ? t('validation.Должно быть не меньше чем') + ` ${min}` : undefined;
};

export const maxValue = (t, max) => (value) => {
  const val = value ?? 0; //Number(value)
  return val > max ? t('validation.Должно быть не больше чем') + ` ${max}` : undefined;
};
